import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { BrowserRouter as Router, Routes, Route, useLocation  } from 'react-router-dom';
import ComputingGalleryManager from './components/gallery/ComputingGalleryManager';
import ExhibitView from './components/ExhibitView';
import AuctionView from './components/auctions/AuctionView'; // Add this import
import './App.css';
import './components/gallery/gallery.css';
import './mobile.css';


// Retrieve your Measurement ID from environment variables
const TRACKING_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "G-B11F2Q3H6D";
ReactGA.initialize(TRACKING_ID);

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    // Send a pageview event every time the URL path changes
    ReactGA.send({ 
      hitType: "pageview", 
      page: location.pathname + location.search 
    });
  }, [location]);

  return (
      <Routes>
          <Route path="/" element={<ComputingGalleryManager />} />
          <Route path="/exhibit/:exhibitId" element={<ExhibitView />} />
          <Route path="/auction/:auctionId" element={<AuctionView />} /> {/* Add this route */}
      </Routes>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}